import { cutText } from './text-parser';

export const getUploadDocumentLabelVariant = (variant, isMobile) => {
  if (variant !== 'responsive') {
    return variant;
  }

  return isMobile ? 'small_2' : 'medium_1';
};

export const getUploadDocumentLabel = ({
  fileName,
  initialText = 'Cargar',
  finalText = ' archivo',
  uploadedText = null,
  truncate = false,
}) => {
  if (fileName) {
    const displayName = uploadedText
      || (truncate ? cutText(fileName, 12, 3) : fileName);

    return {
      primaryText: displayName,
      secondaryText: '',
      hasFile: true,
    };
  }

  return {
    primaryText: initialText,
    secondaryText: finalText,
    hasFile: false,
  };
};
